import AssignStatusProgress from "./assignStatusProgress.container";

export default AssignStatusProgress;
